import React, { useEffect, useMemo, useState } from "react";
import { Global } from "../helpers/Global";

// ✅ Toast global
import { useToast } from "../hooks/useToast";

// ===== MUI =====
import { Box, Paper, Typography, Stack } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";

export const InterProcesoAdmin = () => {
  const toast = useToast();

  // =========================
  // Estado y hooks
  // =========================
  const [ticajes, setTicajes] = useState([]);
  const [loading, setLoading] = useState(true);

  // =========================
  // Carga de datos
  // =========================
  useEffect(() => {
    cargarDatos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const cargarDatos = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${Global.url}ticajes/proceso`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });

      if (!res.ok) {
        toast.error("No se pudieron obtener las intervenciones en proceso.");
        setTicajes([]);
        return;
      }

      const data = await res.json();
      setTicajes(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Error al cargar los ticajes:", error);
      toast.error("Error de conexión con el servidor.");
      setTicajes([]);
    } finally {
      setLoading(false);
    }
  };

  // =========================
  // Utilidades
  // =========================
  const fmtDate = (value) => {
    if (!value) return "-";
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return "-";
    return d.toLocaleString("es-ES", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });
  };

  // =========================
  // Rows / Columns
  // =========================
  const rows = useMemo(
    () =>
      (ticajes || []).map((t) => ({
        ...t,
        inicio_txt: fmtDate(t.inicio),
        comentarios_txt: t.comentarios?.trim() ? t.comentarios : "Sin comentarios",
      })),
    [ticajes]
  );

  const columns = useMemo(
    () => [
      { field: "usuario", headerName: "Usuario", flex: 1, minWidth: 220 },
      { field: "cliente", headerName: "Cliente", flex: 1, minWidth: 220 },
      { field: "centro", headerName: "Centro", flex: 1, minWidth: 220 },
      { field: "inicio_txt", headerName: "Inicio", minWidth: 180 },
      { field: "comentarios_txt", headerName: "Comentarios", flex: 1, minWidth: 260 },
    ],
    []
  );

  // =========================
  // Render
  // =========================
  return (
    <Box className="appContainer appContainer--wide">
      <Stack spacing={2}>
        <Typography variant="h5" sx={{ fontWeight: 700 }}>
          Intervenciones en Proceso
        </Typography>

        <Paper sx={{ height: 640, p: 1 }}>
          <DataGrid
            rows={rows}
            columns={columns}
            getRowId={(row) => row.id}
            disableRowSelectionOnClick
            loading={loading}
            pagination
            initialState={{
              pagination: { paginationModel: { page: 0, pageSize: 25 } },
            }}
            pageSizeOptions={[10, 25, 50, 100]}
            sx={{
              "& .MuiDataGrid-columnHeaders": {
                borderBottom: "1px solid rgba(0,0,0,0.08)",
              },
              "& .MuiDataGrid-cell": {
                borderBottom: "1px solid rgba(0,0,0,0.06)",
              },
            }}
            slots={{
              noRowsOverlay: () => (
                <Box sx={{ p: 2, color: "text.secondary" }}>
                  {loading ? "Cargando…" : "No hay intervenciones activas actualmente."}
                </Box>
              ),
            }}
          />
        </Paper>
      </Stack>
    </Box>
  );
};
